// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","GarageDetailsSection":"GarageDetailsSection_GarageDetailsSection__4r_Gr"};